import React, { useEffect } from 'react'
import { Button, Flex, Select } from 'antd'
import { useStore } from 'effector-react'
import { setPassiveBalanceFilter } from './model'
import { $generateBalanceFilter } from '../generalBalanceFilter/model'
import { useUrlFilters } from '../../../../../libs/useUrlFilters'
import { countries } from 'src/libs/countries'

export const products = [
  { value: 'nova', text: 'NOVA' },
  { value: 'headway', text: 'Headway' },
]

const productOptions = products.map((product) => ({
  value: product.value,
  label: product.text,
}))

const FILTER_CONFIG = {
  product: { type: 'string' as const },
  passiveBalanceCountries: { type: 'array' as const },
}

export const PassiveBalanceFilter: React.FC = () => {
  const generateBalanceFilter = useStore($generateBalanceFilter)
  const { filters, setFilter, setFilters } = useUrlFilters(FILTER_CONFIG)

  const handleResetFilters = () => {
    if (filters.product || (filters.passiveBalanceCountries ?? []).length) {
      setFilters({ product: undefined, passiveBalanceCountries: undefined })
      setPassiveBalanceFilter({
        passiveBalanceCountries: [],
        product: '',
      })
    }
  }

  useEffect(() => {
    if (
      !generateBalanceFilter.date.dateFrom &&
      !generateBalanceFilter.date.dateTo
    ) {
      return
    }
    setFilter('passiveBalanceCountries', generateBalanceFilter.countries)
    setPassiveBalanceFilter({
      product: filters.product ?? '',
      passiveBalanceCountries: generateBalanceFilter.countries,
    })
  }, [generateBalanceFilter])

  return (
    <Flex gap={16} wrap style={{ width: '75%', height: 'auto' }}>
      <Select
        style={{ flex: '1 1 140px', minWidth: 0 }}
        size="large"
        placeholder="Product"
        value={filters.product || undefined}
        options={[{ value: '', label: 'Product' }, ...productOptions]}
        onChange={(value: string) => {
          setFilter('product', value)
          setPassiveBalanceFilter({
            product: value,
            passiveBalanceCountries: filters.passiveBalanceCountries ?? [],
          })
        }}
      />
      <Select
        mode="multiple"
        style={{ flex: '1 1 140px', minWidth: 0 }}
        size="large"
        maxTagCount="responsive"
        placeholder="Countries"
        value={filters.passiveBalanceCountries ?? []}
        options={generateBalanceFilter.countries.map((countryCode) => ({
          value: countryCode,
          label:
            countries.find((country) => country.value === countryCode)?.text ||
            countryCode,
        }))}
        onChange={(values: string[]) => {
          setFilter('passiveBalanceCountries', values)
          setPassiveBalanceFilter({
            product: filters.product ?? '',
            passiveBalanceCountries: values,
          })
        }}
      />
      <Button
        style={{ flex: '1 1 120px', minWidth: 0 }}
        color="primary"
        variant="solid"
        size="large"
        onClick={handleResetFilters}
      >
        Reset filters
      </Button>
    </Flex>
  )
}
